import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const variantClasses = {
    primary: 'bg-indigo-600 text-white hover:bg-indigo-700 active:bg-indigo-800 ' +
        'focus-visible:ring-indigo-500 border-transparent',
    secondary: 'bg-white text-indigo-700 hover:bg-indigo-50 active:bg-indigo-100 ' +
        'focus-visible:ring-indigo-500 border-indigo-300 ' +
        'dark:bg-gray-700 dark:text-indigo-400 dark:hover:bg-gray-600 dark:border-indigo-500',
    ghost: 'bg-transparent text-gray-700 hover:bg-gray-100 active:bg-gray-200 ' +
        'focus-visible:ring-gray-400 border-transparent ' +
        'dark:text-gray-300 dark:hover:bg-gray-700 dark:active:bg-gray-600',
};
export function Button({ variant = 'primary', loading = false, fullWidth = false, disabled, className = '', children, 
// Buttons default to type="submit" inside a form, which silently submits it.
// Callers that want a submit button must opt in explicitly.
type = 'button', ...rest }) {
    const isDisabled = disabled || loading;
    return (_jsxs("button", { ...rest, type: type, disabled: isDisabled, "aria-busy": loading || undefined, className: [
            'relative inline-flex items-center justify-center gap-2',
            'rounded-lg border px-4 py-2 text-sm font-semibold',
            'transition-colors duration-150',
            'focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2',
            'ring-offset-white dark:ring-offset-gray-900',
            'disabled:cursor-not-allowed disabled:opacity-50',
            variantClasses[variant],
            fullWidth ? 'w-full' : '',
            className,
        ]
            .filter(Boolean)
            .join(' '), children: [loading && (_jsx("span", { className: "absolute inset-0 flex items-center justify-center", children: _jsxs("svg", { className: "h-4 w-4 animate-spin", xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", "aria-hidden": "true", children: [_jsx("circle", { className: "opacity-25", cx: "12", cy: "12", r: "10", stroke: "currentColor", strokeWidth: "4" }), _jsx("path", { className: "opacity-75", fill: "currentColor", d: "M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z" })] }) })), _jsx("span", { className: loading ? 'invisible contents' : 'contents', children: children })] }));
}
//# sourceMappingURL=Button.js.map